import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Route,
  Switch,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import { fetchCheckAuthTokenValid, loadAppDetails } from "./slices/AppSlice";
import { AppDispatch } from "./store";
import { routes } from "./router";
import Cookies from "js-cookie";
import "./App.css";
import { getOverseaUrl, getSiteDomain } from "./helpers";
import { AppProvider } from "./providers/app";
function App() {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <div id="app">
      {/* 啊实打实大苏打 */}
      <Switch>
        {routes.map((item) => {
          return (
            <Route
              key={item.path}
              path={item.path}
              component={item.component}
              name={item.name}
            />
          );
        })}
        <Redirect from="/" to="/tools" exact />
        <Redirect to="/404" />
      </Switch>
    </div>
  );
}

export default App;
